module.exports = __webpack_public_path__ + "img/cancellation_curtailment_icon.57d06337.webp";